<div mat-dialog-title
  class="contest-registration-dialog__header">
  @if (isCollective()) {
    <h2 class="contest-registration-dialog__title">{{ "contest.register_class" | translate }}</h2>
  }
  @if (!isCollective()) {
    <h2 class="contest-registration-dialog__title">{{ "contest.register_alone" | translate }}</h2>
  }
  <button mat-button
    class="contest-registration-dialog__close-button"
    (click)="dialogRef.close()"
    [attr.aria-label]="'generic.close' | translate"
    [matTooltip]="'generic.close' | translate">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>
<mat-dialog-content class="contest-registration-dialog__content">
  <form [formGroup]="registrationForm"
    class="contest-registration-dialog__form">
    @if (!isEditing) {
      <div class="contest-registration-dialog__institution">
        <h3 class="contest-registration-dialog__institution-title">{{ "contest.institution_informations" | translate }}</h3>
        <div class="contest-registration-dialog__institution-wrapper">
          <mat-form-field class="contest-registration-dialog__postal-code-field"
            floatLabel="always">
            <mat-label>{{ "generic.postal-code" | translate }}</mat-label>
            <input type="text"
              matInput
              data-e2e="registration-dialog-postal-code"
              [formControlName]="'postalCode'"
              >
            </mat-form-field>
            <!-- Autocomplete pour le nom de l'établissement -->
            @if (contest.collective) {
              <mat-form-field class="contest-registration-dialog__institution-name-field"
                floatLabel="always">
                <mat-label>{{ "groups-management.institution_name" | translate }}</mat-label>
                <input type="text"
                  matInput
                  data-e2e="registration-dialog-establishment-name"
                  [formControlName]="'establishmentName'"
                  [matAutocomplete]="auto2"
                  >
                  <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayFn">
                    @for (etab of filteredEstablishments; track etab) {
                      <mat-option appAriaTitle
                        [value]="etab">
                        <span matTooltip="{{etab.get('name')}} ({{ etab.get('city') }})">{{ etab.get('name') }} ({{ etab.get('city') }})</span>
                      </mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
              }
            </div>
          </div>
        }
        @if (contest.collective) {
          <div class="contest-registration-dialog__groups">
            <h3 class="contest-registration-dialog__groups-title">{{ "contest.selecting_groups" | translate }}</h3>
            @if (classes && classes.length > 0) {
              <div formArrayName="selectedClasses"
                class="contest-registration-dialog__groups-wrapper">
                @for (classe of classes; track classe; let i = $index) {
                  <mat-checkbox
                      data-e2e="registration-select"
                    [formControlName]="i"
                    class="contest-registration-dialog__group-checkbox"
                    labelPosition="before"
                    disableRipple="true">
                    <label class="contest-registration-dialog__group-label">
                      <div class="contest-registration-dialog__group-avatar">6a</div>
                      <div class="contest-registration-dialog__group-name">{{ classe.get('label') }}</div>
                      <div class="contest-registration-dialog__group-learners">
                        <mat-icon svgIcon="group-outlined-fill"></mat-icon>
                        <div>{{ classe.get('membersCount') }}</div>
                      </div>
                    </label>
                  </mat-checkbox>
                }
              </div>
            } @else {
              <div class="no-classes-message">
                {{ 'contest.no_groups' | translate }}
              </div>
            }
          </div>
        }

        @if (!isEditing && isCollective()) {
          <div class="contest-registration-dialog__sponsor">
            <h3 class="contest-registration-dialog__sponsor-title">{{ "contest.sponsor_code" | translate }}</h3>
            <mat-form-field class="contest-registration-dialog__sponsor-code-field"
              floatLabel="always">
              <mat-label>{{ "contest.code" | translate }}</mat-label>
              <input type="text"
                matInput
                data-e2e="registration-dialog-shareable-code"
                formControlName="shareableCode">
              </mat-form-field>
              @if (registrationForm.get('shareableCode').hasError('erreur')) {
                <mat-error>
                  {{ error }}
                </mat-error>
              }
            </div>
          }
          @if (requireConsent) {
            <div class="contest-registration-dialog__consent">
              <mat-checkbox formControlName="consent"
                            data-e2e="registration-consent">
                {{ 'contest.consent' | translate }} *
              </mat-checkbox>
            </div>
          }
        </form>
      </mat-dialog-content>
      <mat-dialog-actions class="contest-registration-dialog__footer">
        <p class="contest-registration-dialog__required-fields-info">{{ "contest.required_fields" | translate }}</p>
        <button mat-button
          type="submit"
          [disabled]="!registrationForm.valid || isRegistering"
          class="contest-registration-dialog__validate-button"
          (click)="handleRegister()">
          <div>{{ "generic.validate" | translate }}</div>
          @if (!isRegistering) {
            <mat-icon svgIcon="check-rounded"></mat-icon>
          } @else {
            <mat-spinner diameter="24"></mat-spinner>
          }
        </button>
      </mat-dialog-actions>